export default __webpack_public_path__ + "static/SectionTwo_02_01@2x-5a3b238be54192dd6269c6063875284d.webp";